import TableCell from '@tiptap/extension-table-cell';

/**
 * Extended TableCell that reads column widths from the table's data-colwidths attribute
 * (set by TableWithColgroup during parsing) and applies them to the colwidth attribute.
 */
export const TableCellWithColwidth = TableCell.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			colwidth: {
				default: null,
				parseHTML: (element) => {
					// First check if the cell has its own colwidth attribute (from Tiptap)
					const existingWidth = element.getAttribute('data-colwidth');
					if (existingWidth) {
						return [Number.parseInt(existingWidth, 10)];
					}

					// Otherwise, try to get it from the table's colgroup data
					const table = element.closest('table');
					if (!table) return null;

					const colwidthsStr = table.getAttribute('data-colwidths');
					if (!colwidthsStr) return null;

					try {
						const colwidths = JSON.parse(colwidthsStr) as number[];

						// Find this cell's column index
						const row = element.closest('tr');
						if (!row) return null;

						const cells = Array.from(row.querySelectorAll('td, th'));
						const colIndex = cells.indexOf(element);

						if (colIndex >= 0 && colIndex < colwidths.length && colwidths[colIndex] > 0) {
							return [colwidths[colIndex]];
						}
					} catch {
						return null;
					}

					return null;
				},
				renderHTML: (attributes) => {
					if (!attributes.colwidth) return {};

					return {
						'data-colwidth': attributes.colwidth[0],
						style: `width: ${attributes.colwidth[0]}px`,
					};
				},
			},
		};
	},
});

export default TableCellWithColwidth;
